import { render, staticRenderFns } from "./TaskDraftMail.vue?vue&type=template&id=7ab20c7e&scoped=true"
import script from "./TaskDraftMail.vue?vue&type=script&lang=js"
export * from "./TaskDraftMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab20c7e",
  null
  
)

export default component.exports